module.exports = __webpack_public_path__ + "img/375.d9ffe3d9.jpg";